import { useEffect, useRef, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useGetCategoryQuery, useAddCatalogMutation, useDeleteCatalogMutation } from '../store/api/directory/categoryApi';
import { Card } from 'primereact/card';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import PresortDemo from '../components/table/DataTable';
import { useAddCountryMutation, useGetCountryQuery } from '../store/api/directory/countryApi';
import { useAddCurrencyMutation, useGetCurrencyQuery } from '../store/api/directory/currencyApi';
import { useGetRegionQuery } from '../store/api/directory/regionApi';
import { useCreateOrUpdateWarehouseMutation, useGetWarehouseQuery } from '../store/api/directory/warehouse';
import { Sidebar } from 'primereact/sidebar';
import Editor from '../components/UI/editor';
import MyButton from '../components/UI/Button';
import { Toast } from "primereact/toast";
import { adressColumn, categoryColumn, currencyColumn, warehouseColumn } from '../metadata/directory';
import { SpeedDial } from 'primereact/speeddial';
import { useTranslation } from 'react-i18next';

export default function CatalogTabs() {
	const [activeIndex, setActiveIndex] = useState(0);
	const [newName, setNewName] = useState('');
	const toast = useRef(null);
	const [columns, setColumns] = useState([])
	const { data: catalogs = [], isLoading } = useGetCategoryQuery();
	const { data: country = [] } = useGetCountryQuery();
	const { data: currency = [] } = useGetCurrencyQuery();
	const { data: region = [] } = useGetRegionQuery();
	const { data: warehouse = [] } = useGetWarehouseQuery();
	const [addCatalog] = useAddCatalogMutation();
	const [addWarehouse] = useCreateOrUpdateWarehouseMutation()
	const [addCurrency] = useAddCurrencyMutation();
	const [deleteCatalog] = useDeleteCatalogMutation();
	const [createOrUpdatecountry] = useAddCountryMutation()
	const { t } = useTranslation();

	const handleDelete = (id) => {
		confirmDialog({
			message: 'Вы уверены, что хотите удалить?',
			header: 'Подтверждение',
			icon: 'pi pi-exclamation-triangle',
			accept: async () => {
				await deleteCatalog({ id }).unwrap();
			},
		});
	};

	const [formData, setFormData] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		if (data?.status == 3 || data?.status == 16) {
			return
		}
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}

	useEffect(() => {
		switch (activeIndex) {
			case 0:
				setColumns(categoryColumn);
				break;
			case 1:
				setColumns(adressColumn);
				break;
			case 2:
				setColumns(currencyColumn);
				break;
			case 3:
				setColumns(categoryColumn);
				break;
			case 4:
				setColumns(warehouseColumn);
				break;
			default:
				setColumns(categoryColumn);
				break;
		}
	}, [activeIndex])

	return (
		<>
			<SpeedDial
				model={[]}
				radius={120}
				type="quarter-circle"
				onClick={() => {
					toggleSidebar(true, {});
				}}
				direction="up-left"
				style={{ right: 15, bottom: 15 }}
			/>
			<Toast ref={toast} />
			<TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} style={{ padding: 0 }}>
				<TabPanel header={t("category")}>
					{isLoading ? (
						<p>Загрузка...</p>
					) : (
						<PresortDemo
							isLoading={isLoading}
							data={catalogs ?? []}
							column={categoryColumn}
							toggleSidebar={toggleSidebar}
							deleteHandler={(row, field) => {
								console.log(row, field);
							}}
							actions={[]}
						/>
					)}
				</TabPanel>

				<TabPanel header={t("adres")}>
					{isLoading ? (
						<p>Загрузка...</p>
					) : (
						<PresortDemo
							isLoading={isLoading}
							data={country ?? []}
							column={adressColumn}
							toggleSidebar={toggleSidebar}
							deleteHandler={(row, field) => {
								console.log(row, field);
							}}
							actions={[]}
						/>
					)}
				</TabPanel>

				<TabPanel header={t("currency_guid")}>
					{isLoading ? (
						<p>Загрузка...</p>
					) : (
						<PresortDemo
							isLoading={isLoading}
							data={currency ?? []}
							column={currencyColumn}
							toggleSidebar={toggleSidebar}
							deleteHandler={(row, field) => {
								console.log(row, field);
							}}
							actions={[]}
						/>
					)}
				</TabPanel>

				<TabPanel header={t("region")}>
					{isLoading ? (
						<p>Загрузка...</p>
					) : (
						<PresortDemo
							isLoading={isLoading}
							data={region ?? []}
							column={(Array.isArray(region) && region.length) ? Object.keys(region?.[0]).map(item => ({ attr: item, label: item })) : []}
							toggleSidebar={() => { }}
							deleteHandler={(row, field) => {
								console.log(row, field);
							}}
							actions={[]}
						/>
					)}
				</TabPanel>

				<TabPanel header={t("warehouse")}>
					{isLoading ? (
						<p>Загрузка...</p>
					) : (
						<PresortDemo
							isLoading={isLoading}
							data={warehouse?.result ?? []}
							column={warehouseColumn}
							toggleSidebar={() => { }}
							deleteHandler={(row, field) => {
								console.log(row, field);
							}}
							actions={[]}
						/>
					)}
				</TabPanel>
			</TabView>

			<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
				<div className="user-sidebar">

					<div className="user-sidebar-edit">
						{
							columns.filter((i) => i.editor).map(el => {
								return (
									<div>
										<Editor {...el} onBlur={onBlur} data={formData} />
									</div>
								)
							})
						}
						<div></div>
						<MyButton label={t('save')} onClick={async () => {
							if (activeIndex == 0) {
								await addCatalog(formData);
							}
							if (activeIndex == 1) {
								await createOrUpdatecountry(formData);
							}
							if (activeIndex == 2) {
								await addCurrency(formData);
							}
							if (activeIndex == 4) {
								await addWarehouse(formData)
							}
							toast.current.show({ severity: 'info', summary: 'Success', detail: t("successSaved"), life: 3000 });
							toggleSidebar(false)
						}} />
					</div>
				</div>

			</Sidebar>

			<ConfirmDialog />
		</>
	);
}
